import * as Yup from 'yup';
import {
  CasErrorDisplay,
  CasLoaderWithBackdrop,
  CasReactHookFormDialog,
  CasRHFMultilineTextField,
} from 'src/compass/shared/components';

import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';
import { IGeneralObjectType } from 'src/compass/site/util';
import { useRetrieveDetailsById } from 'src/compass/shared/hooks/reactQuery/useRetrieveDetailsById';
import { getMaxStringSchema } from 'src/compass/shared/schemas';
import SceReportsHeaderInfo from './SceReportsHeaderInfo';

export const Schema = Yup.object().shape({
  allocationNotes: getMaxStringSchema().required('Allocation Instructions is required.'),
});

type Props = {
  endorsementId: number;
  onClose: VoidFunction;
  onUpdated: Function;
};

export default function AllocationInstructionsDialog({ endorsementId, onClose, onUpdated }: Props) {
  const { data, isFetching, isError } = useRetrieveDetailsById({
    entity: `Navigator/SCEReports`,
    id: endorsementId,
  });

  const { mutate } = useUpdateMutation({
    url: 'Navigator/SCEReports/UpdateAllocationNotes',
    params: { endorsementId },
    onSuccess: (response) => {
      onSuccessEnqueueSnackbar(response);
      onUpdated();
      onClose();
    },
  });

  const onSubmit = (payload: IGeneralObjectType) => mutate(payload);

  if (isFetching) return <CasLoaderWithBackdrop />;

  if (isError) throw new Error('Error retrieving data from the server.');

  return (
    <CasReactHookFormDialog
      open
      maxWidth="lg"
      title="Edit SCE Allocation Instructions"
      submitButtonLabel="Save"
      defaultValues={data}
      onClose={onClose}
      onSubmit={onSubmit}
      schema={Schema}
      buttonProps={{ disabled: !data.canChangeAllocationNotes }}
    >
      <SceReportsHeaderInfo data={data} />
      <CasRHFMultilineTextField
        label="Allocation Instructions"
        name="allocationNotes"
        disabled={!data?.canChangeAllocationNotes}
        helperText={
          !data.canChangeAllocationNotes && (
            <CasErrorDisplay message="SCE has been posted.  Direct change not allowed - Contact Mid-Office." />
          )
        }
      />
    </CasReactHookFormDialog>
  );
}
